import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import { useTheme } from '@mui/material/styles';
import clsx from 'clsx';
import Loading from 'components/Loading';

const variantTypes = {
    error: 'error',
    warning: 'warning',
    info: 'info',
    success: 'success',
    none: 'none'
};

class ComponentContainer extends Component {

    state = {
        message: {
            show: false,
            type: variantTypes.none,
            autoHideDuration: 6000
        }
    };

    render() {
        const mergedProps = {
            ...this.props,
            showErrorMessage: this.showErrorMessage,
            showWarningMessage: this.showWarningMessage,
            showInformationMessage: this.showInformationMessage,
            showSuccessMessage: this.showSuccessMessage
        }

        const { loading } = this.props;
        const { message } = this.state;

        return (
            <div>
                <div className={loading === true ? '' : 'collapse'}>
                    <Loading />
                </div>
                <div className={loading !== true ? 'animated slideInUpTiny animation-duration-3' : 'collapse'}>
                    {typeof (this.props.children) === 'function' ? this.props.children(mergedProps) : this.props.children}
                </div>

                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={message.show}
                    autoHideDuration={message.autoHideDuration}
                    onClose={this.handleSnackbarClose}
                    ContentProps={{
                        'aria-describedby': 'client-snackbar',
                    }}
                >
                    <SnackbarContentWrapper onClose={this.handleSnackbarClose} variant={message.type} message={message.content} />
                </Snackbar>

            </div>
        );
    }

    showErrorMessage = (message, showAfterRedirect = false, autoHideDuration = 6000) => {
        this.showMessage(variantTypes.error, message, showAfterRedirect, autoHideDuration)
    };

    showWarningMessage = (message, showAfterRedirect = false, autoHideDuration = 6000) => {
        this.showMessage(variantTypes.warning, message, showAfterRedirect, autoHideDuration)
    };

    showInformationMessage = (message, showAfterRedirect = false, autoHideDuration = 6000) => {
        this.showMessage(variantTypes.info, message, showAfterRedirect, autoHideDuration)
    };

    showSuccessMessage = (message, showAfterRedirect = false, autoHideDuration = 6000) => {
        this.showMessage(variantTypes.success, message, showAfterRedirect, autoHideDuration);
    };

    showMessage = (variant, message, showAfterRedirect = false, autoHideDuration = 6000) => {
        this.setState({
            message: {
                type: variant,
                content: message,
                show: showAfterRedirect === false,
                autoHideDuration
            }
        });
    };

    handleSnackbarClose = (event, reason) => {
        this.setState({
            message: {
                show: false,
                type: variantTypes.none
            }
        });
    };
}

export default injectIntl(ComponentContainer);

const SnackbarContentWrapper = (props) => {
    const theme = useTheme();
    const classes = theme.styles.alert();
    const { className, message, variant } = props;

    if (variant && variant !== variantTypes.none) {
        const Icon = iconTypes[variant];

        return (
            <SnackbarContent
                className={clsx(classes[variant], className)}
                aria-describedby="client-snackbar"
                message={
                    <span id="client-snackbar" className={classes.message}>
                        <Icon className={clsx(classes.icon, classes.iconVariant)} />
                        {message}
                    </span>
                }
            />
        );
    }

    return (<div></div>);

}

SnackbarContentWrapper.propTypes = {
    className: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onClose: PropTypes.func,
    variant: PropTypes.oneOf([variantTypes.error, variantTypes.warning, variantTypes.info, variantTypes.success, variantTypes.none]).isRequired,
};

const iconTypes = {
    [variantTypes.success]: CheckCircleIcon,
    [variantTypes.warning]: WarningIcon,
    [variantTypes.error]: ErrorIcon,
    [variantTypes.info]: InfoIcon,
};